/**
 * @desc 保存
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.declareContract.save.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/declareContract/save`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
